import { AuthenticationService } from './authentication.service';
import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { Router } from '@angular/router';
import { map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationGuard implements CanActivate {
  url: any;
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {
    return this.authenticationService.getStatus().pipe(
      switchMap((status) => {
        if (!status) {
          return of(this.router.createUrlTree(['']));
        }

        return this.authenticationService.getUserByUid(status.uid).pipe(
          map((userDocs) => {
            if (userDocs.length === 0) {
              return this.router.createUrlTree(['']);
            }

            const user: any = userDocs[0];
            const role = user.role;
            const requestedUrl = state.url;

            if (role === 'admin') {
              if (requestedUrl.startsWith('/admin')) {
                return true;
              }
              return this.router.createUrlTree(['/admin']);
            }

            if (role === 'parent') {
              if (requestedUrl.startsWith('/padres')) {
                return true;
              }
              return this.router.createUrlTree(['/padres']);
            }

            if (role === 'external') {
              if (requestedUrl.startsWith('/externo')) {
                return true;
              }
              return this.router.createUrlTree(['/externo']);
            }

            if (requestedUrl.startsWith('/dashboard')) {
              return true;
            }
            return this.router.createUrlTree(['/dashboard']);
          })
        );
      })
    );
  }
}
